import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "content title"
};
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
import OddsHistoryTable from './OddsHistoryTable.vue';
import CrsBlock from './CrsBlock.vue';
export default {
  __name: 'AnalyzeView',
  setup(__props, {
    expose: __expose
  }) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const title = ref('');
    const isVisible = ref(false);
    const oddsHistory = ref({});
    const sections = ref([]);
    const crsList = ref([]);

    // 半全场组合中文标签
    const HAFU_LABELS = {
      hh: '胜胜',
      hd: '胜平',
      ha: '胜负',
      dh: '平胜',
      dd: '平平',
      da: '平负',
      ah: '负胜',
      ad: '负平',
      aa: '负负'
    };

    // 显示弹出框
    const show = matchId => {
      isVisible.value = true;
      getFixedBonusV1(matchId);
    };
    const getFixedBonusV1 = async matchId => {
      try {
        const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getFixedBonusV1.qry?clientCode=3001&matchId=' + matchId);
        let data = response.data;
        if (data.success) {
          oddsHistory.value = data.value.oddsHistory;
          title.value = oddsHistory.value.homeTeamAbbName + ' VS ' + oddsHistory.value.awayTeamAbbName;
          sections.value = buildSections();
          crsList.value = oddsHistory.value.crsList || [];
        } else {
          timeNotify(data.errorMessage);
        }
      } catch (error) {
        console.error(error);
      }
    };

    /**
     * 构造所有玩法的赔率变化表格数据
     * 每个玩法：标题 + 列定义(选项) + 行数据(每个时间点，含涨跌方向)
     */
    const buildSections = () => {
      const had = oddsHistory.value;
      if (!had) return [];
      const secs = [];
      secs.push({
        title: '胜平负',
        columns: [{
          key: 'h',
          label: '胜'
        }, {
          key: 'd',
          label: '平'
        }, {
          key: 'a',
          label: '负'
        }],
        rows: buildRows(had.hadList, ['h', 'd', 'a'])
      });
      const gl = had.hhadList && had.hhadList[0] ? had.hhadList[0].goalLine : '';
      const glLabel = gl === '' ? '平手' : gl;
      secs.push({
        title: '让球胜平负(' + glLabel + ')',
        columns: [{
          key: 'h',
          label: '让胜'
        }, {
          key: 'd',
          label: '让平'
        }, {
          key: 'a',
          label: '让负'
        }],
        rows: buildRows(had.hhadList, ['h', 'd', 'a'])
      });
      secs.push({
        title: '总进球数',
        columns: [{
          key: 's0',
          label: '0'
        }, {
          key: 's1',
          label: '1'
        }, {
          key: 's2',
          label: '2'
        }, {
          key: 's3',
          label: '3'
        }, {
          key: 's4',
          label: '4'
        }, {
          key: 's5',
          label: '5'
        }, {
          key: 's6',
          label: '6'
        }, {
          key: 's7',
          label: '7+'
        }],
        rows: buildRows(had.ttgList, ['s0', 's1', 's2', 's3', 's4', 's5', 's6', 's7'])
      });
      const hafuKeys = Object.keys(HAFU_LABELS);
      secs.push({
        title: '半全场',
        columns: hafuKeys.map(k => ({
          key: k,
          label: HAFU_LABELS[k]
        })),
        rows: buildRows(had.hafuList, hafuKeys)
      });

      // 比分单独用 CrsBlock 组件展示（参考官方：每个时间段一个整体块，主胜/平局/负三段）

      return secs;
    };

    /**
     * 将每个时间点的赔率数据转为表格行
     * @param {Array} list 某玩法的时序数据（含 updateTime、各选项赔率、各选项 f 涨跌标记）
     * @param {Array<string>} keys 选项字段
     * @return {Array<{time:string, tag:string, cells:Object}>}
     */
    const buildRows = (list, keys) => {
      const arr = list || [];
      return arr.map((x, i) => ({
        time: formatTime(x.updateTime),
        tag: i === 0 ? '初始' : i === arr.length - 1 ? '最新' : '',
        cells: keys.reduce((acc, k) => {
          acc[k] = {
            v: x[k],
            dir: Number(x[k + 'f']) || 0
          };
          return acc;
        }, {})
      }));
    };

    /** 时间只显示 HH:mm */
    const formatTime = t => t && String(t).length >= 5 ? String(t).substring(0, 5) : t || '';

    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '24px 2px',
          height: '85%',
          width: '92%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(title.value), 1), _createVNode(OddsHistoryTable, {
          sections: sections.value
        }, null, 8, ["sections"]), _createVNode(CrsBlock, {
          list: crsList.value
        }, null, 8, ["list"])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};